import React, { useEffect } from 'react';
import { Hero } from './Hero';
import { Story } from './Story';
import { Quotes } from './Quotes';
import { BookDetails } from './BookDetails';
import { SpecialOffer } from './SpecialOffer';
import { FAQ } from './FAQ';
import { Footer } from './Footer';
export const BookPromo = () => {
  useEffect(() => {
    // Debug log to check component rendering
    console.log('BookPromo component mounted');
    // Check if Hero section is in DOM
    const heroElement = document.querySelector('.hero-section');
    console.log('Hero section found:', !!heroElement);
  }, []);
  return <div className="w-full" data-id="element-31">
      {/* Add debugging border and explicit height to ensure visibility */}
      <div className="debug-hero-wrapper" style={{
      minHeight: '200px'
    }} data-id="element-32">
        <Hero data-id="element-33" />
      </div>
      <Story data-id="element-34" />
      <Quotes data-id="element-35" />
      <BookDetails data-id="element-36" />
      <SpecialOffer data-id="element-37" />
      <FAQ data-id="element-38" />
      <Footer data-id="element-39" />
    </div>;
};